<script>
  import {checkbox} from 'vue-strap';
  import radio from '~componentes/Radio.vue'
  
  export default {
    components: {checkbox, radio},
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      produtos: {
        required: true
      },
      tiposProdutos: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      observacaoItemCompraContador: function() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ? 
            this.itemSolicitacao.observacaoItemCompra.length : 0;

        return 500 - quantidadeCaracteres;
      },
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      }
    }
  }
</script>

<template>
    <div>
        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                    <label class="control-label" for="tipoProduto">Tipo de produto</label>

                    <select class="form-control"
                            id="tipoProduto"
                            v-model="itemSolicitacao.idTipoProduto"
                            data-vv-name="tipoProduto"
                            data-vv-as="tipo de produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="tipoProduto.idTipoProduto"
                                v-for="tipoProduto in tiposProdutos">
                            {{ tipoProduto.nomeTipoProduto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                    <label class="control-label" for="produto">Produto</label>

                    <select class="form-control"
                            id="produto"
                            v-model="itemSolicitacao.idProduto"
                            data-vv-name="produto"
                            data-vv-as="produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="produto.idProduto"
                                v-for="produto in produtos">
                            {{ produto.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="{'col-xs-4': configuracao.utilizarValorEstimado && configuracao.mostrarUnidadeSolicitacaoCompraItemServicos, 'col-xs-6': configuracao.utilizarValorEstimado || configuracao.mostrarUnidadeSolicitacaoCompraItemServicos, 'col-xs-12': !configuracao.utilizarValorEstimado && !configuracao.mostrarUnidadeSolicitacaoCompraItemServicos}">
                <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
                    <label class="control-label" for="quantidade">Quantidade</label>

                    <input type="text"
                           class="form-control text-right"
                           id="quantidade"
                           v-model="itemSolicitacao.quantidade"
                           data-vv-name="quantidade"
                           v-validate="'required|not_zero'"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                </div>
            </div>

            <div :class="{'col-xs-4': configuracao.utilizarValorEstimado, 'col-xs-6': !configuracao.utilizarValorEstimado}"
                 v-if="configuracao.mostrarUnidadeSolicitacaoCompraItemServicos">
                <div class="form-group required" :class="{'has-error': errors.has('unidade')}">
                    <label class="control-label" for="unidade">Unidade</label>

                    <input type="text"
                           class="form-control"
                           id="unidade"
                           v-model="itemSolicitacao.unidade"
                           data-vv-name="unidade"
                           v-validate="'required'"
                           maxlength="30">

                    <p class="text-danger" v-show="errors.has('unidade')">{{ errors.first('unidade') }}</p>
                </div>
            </div>

            <div :class="{'col-xs-4': configuracao.mostrarUnidadeSolicitacaoCompraItemServicos, 'col-xs-6': !configuracao.mostrarUnidadeSolicitacaoCompraItemServicos}"
                 v-if="configuracao.utilizarValorEstimado">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
                    <label class="control-label" for="descricao-material">Descrição do material/serviço</label>

                    <textarea class="form-control"
                              id="descricao-material"
                              v-model="itemSolicitacao.descricao"
                              v-validate="'required'"
                              data-vv-name="descricaoMaterial"
                              data-vv-as="descrição do material/serviço">
          </textarea>

                    <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group" :class="{'has-error': errors.has('nomePrestador'), 'required': configuracao.solCompraObrigatorioPrestadorServicos}">
                    <label class="control-label" for="nome-prestador">Nome do prestador do serviço</label>

                    <input type="text"
                           class="form-control"
                           id="nome-prestador"
                           v-model="itemSolicitacao.nomePrestador"
                           v-validate="`${configuracao.solCompraObrigatorioPrestadorServicos ? 'required' : ''}`"
                           data-vv-name="nomePrestador"
                           data-vv-as="nome do prestador do serviço"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('nomePrestador')">{{ errors.first('nomePrestador') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-6">
                <div class="form-group" :class="{'has-error': errors.has('telefonePrestador'), 'required': configuracao.solCompraObrigatorioPrestadorServicos}">
                    <label class="control-label" for="telefone-prestador">Telefone</label>

                    <input type="text"
                           class="form-control"
                           id="telefone-prestador"
                           v-model="itemSolicitacao.telefonePrestador"
                           v-validate="`${configuracao.solCompraObrigatorioPrestadorServicos ? 'required' : ''}`"
                           data-vv-name="telefonePrestador"
                           data-vv-as="telefone"
                           v-mascara="'telefone'">

                    <p class="text-danger" v-show="errors.has('telefonePrestador')">{{ errors.first('telefonePrestador') }}</p>
                </div>
            </div>

            <div class="col-xs-6">
                <div class="form-group" :class="{'has-error': errors.has('emailPrestador'), 'required': configuracao.solCompraObrigatorioPrestadorServicos}">
                    <label class="control-label" for="email-prestador">E-mail</label>

                    <input type="text"
                           class="form-control"
                           id="email-prestador"
                           v-model="itemSolicitacao.emailPrestador"
                           v-validate="`${configuracao.solCompraObrigatorioPrestadorServicos ? `required|emailcomposto` : 'emailcomposto'}`"
                           data-vv-name="emailPrestador"
                           data-vv-as="e-mail"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('emailPrestador')">{{ errors.first('emailPrestador') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-6" :class="{'has-error': errors.has('contrato')}">
                <p class="no-margins required" :class="{'text-danger': errors.has('contrato')}"><b>Contrato?</b></p>

                <div class="form-group no-margin-bottom">
                    <radio v-model="itemSolicitacao.contrato"
                           v-validate="'required'"
                           selected-value="true"
                           data-vv-name="contrato"
                           type="success"
                           class="margin-right-10"
                           :inline="true">
                        Sim
                    </radio>

                    <radio v-model="itemSolicitacao.contrato"
                           selected-value="false"
                           data-vv-name="contrato"
                           type="success"
                           :inline="true">
                        Não
                    </radio>

                    <p class="text-danger" v-show="errors.has('contrato')">{{ errors.first('contrato') }}</p>
                </div>
            </div>

            <div class="col-xs-6" :class="{'has-error': errors.has('aditivo')}">
                <p class="no-margins required" :class="{'text-danger': errors.has('aditivo')}"><b>Aditivo?</b></p>

                <div class="form-group no-margin-bottom">
                    <radio v-model="itemSolicitacao.aditivo"
                           v-validate="'required'"
                           selected-value="true"
                           data-vv-name="aditivo"
                           type="success"
                           class="margin-right-10"
                           :inline="true">
                        Sim
                    </radio>

                    <radio v-model="itemSolicitacao.aditivo"
                           selected-value="false"
                           data-vv-name="aditivo"
                           type="success"
                           :inline="true">
                        Não
                    </radio>

                    <p class="text-danger" v-show="errors.has('aditivo')">{{ errors.first('aditivo') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de compra (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="observacao-item-compra">Observação do item de compra ({{ observacaoItemCompraContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemCompra"
                              maxlength="500">
          </textarea>
                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormContratacaoDeServicos.vue